import instance from 'utils/axios/instance.axios';
import { COUNCILS } from './_constant';

export const getAll = (councilIds, projectProposalId) =>
  instance.get(COUNCILS.GET_ALL, { params: { councilIds, projectProposalId } });

export const getById = (data) => instance.get(COUNCILS.GET_BY_ID, { params: { ...data } });

export const downloadFile = (data = {}) =>
  instance.post(COUNCILS.DOWNLOAD_FILE, data, { responseType: 'blob' });

export const getAllByProjectId = (id) => instance.get(COUNCILS.GET_ALL_BY_PROJECT_ID(id));

export const getAllCouncilTypes = () => instance.get(COUNCILS.GET_ALL_COUNCIL_TYPES);
